import { render } from "./Buy.vue?vue&type=template&id=01af3b1e&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"

import "./Buy.vue?vue&type=style&index=0&id=01af3b1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01af3b1e"]])

export default __exports__